module.exports = __webpack_public_path__ + "img/500-bg-right.1722b37.webp";